import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Text, Notice } from '@companycam/slab-web';
import styled from 'styled-components';

const SearchResultsIcon = styled.i`
  font-size: 28px;
  color: var(--cc_color_text_nonessential);
`;

const SelectMessage = styled.div`
  padding: var(--cc_size_spacing_m);
  display: grid;
  gap: var(--cc_size_spacing_s);
  place-items: center;
  text-align: center;
  line-height: 1.25;
`;

const messages = defineMessages({
  errorMessage: {
    id: 'AssignUser.searchErrorMessage',
    defaultMessage: 'Error loading users',
    description: 'error message for when users fail to load',
  },
  noResultsMessage: {
    id: 'AssignUser.searchNoResultsMessage',
    defaultMessage: 'No users found.',
    description: 'message for when no users are found',
  },
});

type NoOptionsMessageProps = {
  hasGetAssignableUsersError: boolean;
};

const NoOptionsMessage = ({
  hasGetAssignableUsersError,
}: NoOptionsMessageProps) => {
  const intl = useIntl();

  return hasGetAssignableUsersError ? (
    <Notice color="destroy" size="small">
      {intl.formatMessage(messages.errorMessage)}
    </Notice>
  ) : (
    <SelectMessage>
      <SearchResultsIcon className="mdi mdi-scan-helper" />
      <Text as="p">{intl.formatMessage(messages.noResultsMessage)}</Text>
    </SelectMessage>
  );
};

export default NoOptionsMessage;
